import { render, staticRenderFns } from "./SalesPurchaseLedger.vue?vue&type=template&id=72f3816e&scoped=true&"
import script from "./SalesPurchaseLedger.vue?vue&type=script&lang=js&"
export * from "./SalesPurchaseLedger.vue?vue&type=script&lang=js&"
import style0 from "./SalesPurchaseLedger.vue?vue&type=style&index=0&id=72f3816e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3816e",
  null
  
)

export default component.exports